<template>
  <input
    type="text"
    :class="classList"
    :value="content.text"
    @input="onInput"
    @mouseover="hoverOn"
    @mouseleave="hoverOff"
    @focus="focusOn"
    @blur="focusOff"
    @click="clicked"
  >
</template>

<script>
export default {
  name: 'default',
  props : {
    content: {
      type: Object,
      required: true,
    },
    styles: {
      type: String,
      default: ""
    },
  },
  emits : ['events'],
  data() {
    return {
      hover: false,
      focus: false,
    }
  },
  computed : {
    id() {
      return this.content?.id || ""
    },
    classList() {
      // Import & defaults
      let importOBJ = this.$styles.get(this.styles)
      let iAlign = importOBJ.align || "l"
      iAlign = "align-" + iAlign
      let iMain = importOBJ.main || "h"
      iMain = "main-" + iMain
      let iBg = importOBJ.bg || "0"
      iBg = "bg-" + iBg
      let iFont = importOBJ.font || "m"
      iFont = "font-" + iFont
      let iPad = importOBJ.pad  || "m"
      iPad = "pad-" + iPad
      let iPLeft = importOBJ.pleft  || "08"
      iPLeft = "pleft-" + iPLeft

      return ['component', 'border-none', iMain, iAlign, iBg, iFont, iPad, iPLeft]
    },
  },
  methods : {
      onInput(event) {
        this.$emit('events', 'onInput', this.id, event.target.value)
      },
      hoverOn() {
        this.hover = true
        this.$emit('events', 'hoverOn', this.id)
      },
      hoverOff() {
        this.hover = false
        this.$emit('events', 'hoverOff', this.id)
      },
      focusOn(event) {
        this.focus = true
        this.$emit('events', 'focusOn', this.id, event.target.value)
      },
      focusOff() {
        this.focus = false
        this.$emit('events', 'focusOff', this.id)
      },
  },
}
</script>

<style scoped>
.component {
  width: 100%; /* needed for correct sizing */
}
</style>